import CampaignCreationSlideContainer from "./CampaignCreationSlideContainer";

export default CampaignCreationSlideContainer;
